import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { verifyEmailToken, formatApiErrorDetail } from "../lib/api";
import { Reveal } from "../components/Motion";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState("verifying");
  const [error, setError] = useState("");

  useEffect(() => {
    document.title = "Verify Email — Motion & Meaning";
    if (!token) return setState("invalid");
    verifyEmailToken({ token })
      .then(() => setState("done"))
      .catch((e) => { setError(formatApiErrorDetail(e.response?.data?.detail) || e.message); setState("error"); });
  }, [token]);

  return (
    <section className="relative min-h-screen flex items-center" data-testid="verify-email-page">
      <div className="mm-vignette" />
      <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-12 w-full pt-32 pb-24">
        <Reveal>
          <p className="font-mono text-[11px] tracking-[0.4em] text-gold mb-6">ACCOUNT VERIFICATION</p>
          {state === "verifying" && <h1 className="font-serif text-5xl font-light text-white">Confirming your signal…</h1>}
          {state === "done" && (
            <div data-testid="verify-success">
              <h1 className="font-serif text-5xl md:text-6xl font-light text-white">Signal<br />confirmed.</h1>
              <p className="text-white/60 mt-8 max-w-md">Your email is verified. Your account is fully connected to the Motion & Meaning universe.</p>
              <Link to="/account" className="inline-block mt-10 bg-gold text-black font-mono text-[11px] tracking-[0.25em] px-10 py-4 hover:bg-white transition-colors">MY ACCOUNT</Link>
            </div>
          )}
          {(state === "error" || state === "invalid") && (
            <div data-testid="verify-error">
              <h1 className="font-serif text-5xl font-light text-white">Invalid link.</h1>
              <p className="text-white/60 mt-8 max-w-md">{error || "This verification link is missing or malformed."}</p>
              <Link to="/account" className="inline-block mt-10 font-mono text-[11px] tracking-[0.25em] text-gold hover:text-white">GO TO MY ACCOUNT →</Link>
            </div>
          )}
        </Reveal>
      </div>
    </section>
  );
}
